// ─── Shared option sets ──────────────────────────────────────────────────────

const MOOD_OPTIONS = [
  { value: '', label: '— Select —' },
  { value: 'euthymic', label: 'Euthymic' },
  { value: 'depressed', label: 'Depressed' },
  { value: 'anxious', label: 'Anxious' },
  { value: 'irritable', label: 'Irritable' },
  { value: 'elevated', label: 'Elevated' },
  { value: 'dysphoric', label: 'Dysphoric' },
  { value: 'mixed', label: 'Mixed' },
  { value: 'labile', label: 'Labile' },
];

const AFFECT_OPTIONS = [
  { value: '', label: '— Select —' },
  { value: 'congruent', label: 'Congruent' },
  { value: 'flat', label: 'Flat' },
  { value: 'blunted', label: 'Blunted' },
  { value: 'labile', label: 'Labile' },
  { value: 'expansive', label: 'Expansive' },
  { value: 'restricted', label: 'Restricted' },
  { value: 'incongruent', label: 'Incongruent' },
];

const RISK_LEVEL_OPTIONS = [
  { value: '', label: '— Select —' },
  { value: 'none', label: 'None' },
  { value: 'low', label: 'Low' },
  { value: 'moderate', label: 'Moderate' },
  { value: 'high', label: 'High' },
  { value: 'imminent', label: 'Imminent' },
];

const SI_OPTIONS = [
  { value: '', label: '— Select —' },
  { value: 'none', label: 'None' },
  { value: 'passive', label: 'Passive' },
  { value: 'active_without_plan', label: 'Active without plan' },
  { value: 'active_with_plan', label: 'Active with plan' },
  { value: 'active_with_intent', label: 'Active with intent' },
];

const HI_OPTIONS = [
  { value: '', label: '— Select —' },
  { value: 'none', label: 'None' },
  { value: 'present', label: 'Present' },
];

const SH_OPTIONS = [
  { value: '', label: '— Select —' },
  { value: 'none', label: 'None' },
  { value: 'current', label: 'Current' },
  { value: 'historical', label: 'Historical' },
];

const MODALITY_OPTIONS = [
  { value: 'individual', label: 'Individual' },
  { value: 'group', label: 'Group' },
  { value: 'family', label: 'Family' },
  { value: 'couples', label: 'Couples' },
  { value: 'telehealth', label: 'Telehealth' },
];

const EBI_OPTIONS = [
  { value: 'cbt', label: 'Cognitive Behavioral Therapy (CBT)' },
  { value: 'dbt', label: 'Dialectical Behavior Therapy (DBT)' },
  { value: 'act', label: 'Acceptance and Commitment Therapy (ACT)' },
  { value: 'emdr', label: 'EMDR' },
  { value: 'mi', label: 'Motivational Interviewing' },
  { value: 'mindfulness', label: 'Mindfulness-based interventions' },
  { value: 'psychoeducation', label: 'Psychoeducation' },
  { value: 'other', label: 'Other' },
];

const GOAL_STATUS_OPTIONS = [
  { value: '', label: '— Select —' },
  { value: 'not_started', label: 'Not started' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'met', label: 'Met' },
  { value: 'discontinued', label: 'Discontinued' },
];

const THOUGHT_PROCESS_OPTIONS = [
  { value: '', label: '— Select —' },
  { value: 'logical', label: 'Logical / Linear' },
  { value: 'tangential', label: 'Tangential' },
  { value: 'circumstantial', label: 'Circumstantial' },
  { value: 'flight_of_ideas', label: 'Flight of Ideas' },
  { value: 'disorganized', label: 'Disorganized' },
  { value: 'loosening', label: 'Loosening of Associations' },
];

const PERCEPTION_OPTIONS = [
  { value: '', label: '— Select —' },
  { value: 'no_abnormality', label: 'No abnormality' },
  { value: 'auditory_hallucinations', label: 'Auditory hallucinations' },
  { value: 'visual_hallucinations', label: 'Visual hallucinations' },
  { value: 'other', label: 'Other' },
];

const INSIGHT_OPTIONS = [
  { value: '', label: '— Select —' },
  { value: 'good', label: 'Good' },
  { value: 'fair', label: 'Fair' },
  { value: 'limited', label: 'Limited' },
  { value: 'poor', label: 'Poor' },
];

const JUDGMENT_OPTIONS = [
  { value: '', label: '— Select —' },
  { value: 'good', label: 'Good' },
  { value: 'fair', label: 'Fair' },
  { value: 'impaired', label: 'Impaired' },
];

const RELATIONSHIP_STATUS_OPTIONS = [
  { value: '', label: '— Select —' },
  { value: 'single', label: 'Single' },
  { value: 'partnered', label: 'Partnered / Dating' },
  { value: 'married', label: 'Married' },
  { value: 'separated', label: 'Separated' },
  { value: 'divorced', label: 'Divorced' },
  { value: 'widowed', label: 'Widowed' },
];

const PROGNOSIS_OPTIONS = [
  { value: '', label: '— Select —' },
  { value: 'excellent', label: 'Excellent' },
  { value: 'good', label: 'Good' },
  { value: 'fair', label: 'Fair' },
  { value: 'guarded', label: 'Guarded' },
  { value: 'poor', label: 'Poor' },
];

const SUBSTANCE_ALCOHOL_OPTIONS = [
  { value: '', label: '— Select —' },
  { value: 'none', label: 'None' },
  { value: 'social', label: 'Social' },
  { value: 'problematic', label: 'Problematic' },
];

const SUBSTANCE_CANNABIS_OPTIONS = [
  { value: '', label: '— Select —' },
  { value: 'none', label: 'None' },
  { value: 'occasional', label: 'Occasional' },
  { value: 'regular', label: 'Regular' },
];

// ─── Shared section fragments ─────────────────────────────────────────────────

const SESSION_INFO_SECTION = {
  title: 'Session Info',
  columns: 2,
  fields: [
    { key: 'sessionDuration', label: 'Duration (minutes)', type: 'number', placeholder: '50' },
    { key: 'sessionNumber', label: 'Session #', type: 'number' },
  ],
};

const MENTAL_STATUS_BRIEF_SECTION = {
  title: 'Mental Status',
  columns: 2,
  fields: [
    { key: 'mood', label: 'Mood', type: 'select', options: MOOD_OPTIONS },
    { key: 'affect', label: 'Affect', type: 'select', options: AFFECT_OPTIONS },
  ],
};

const SESSION_RISK_SECTION = {
  title: 'Risk Assessment',
  columns: 2,
  fields: [
    { key: 'riskLevel', label: 'Risk Level', type: 'select', options: RISK_LEVEL_OPTIONS },
    { key: 'riskSuicidalIdeation', label: 'Suicidal Ideation', type: 'select', options: SI_OPTIONS },
    { key: 'riskHomicidalIdeation', label: 'Homicidal Ideation', type: 'select', options: HI_OPTIONS },
    { key: 'riskNotes', label: 'Risk Notes / Action Taken', type: 'textarea', rows: 2 },
  ],
};

const MSE_COLUMNS_SECTION = {
  title: 'Mental Status Examination',
  columns: 2,
  fields: [
    { key: 'mseAppearance', label: 'Appearance', type: 'text' },
    { key: 'mseBehavior', label: 'Behavior / Psychomotor', type: 'text' },
    { key: 'mseSpeech', label: 'Speech', type: 'text' },
    { key: 'mseMood', label: 'Mood', type: 'select', options: MOOD_OPTIONS },
    { key: 'mseAffect', label: 'Affect', type: 'select', options: AFFECT_OPTIONS },
    { key: 'mseThoughtProcess', label: 'Thought Process', type: 'select', options: THOUGHT_PROCESS_OPTIONS },
    { key: 'mseThoughtContent', label: 'Thought Content', type: 'text', hint: 'Preoccupations, intrusive thoughts, delusions' },
    { key: 'msePerceptions', label: 'Perceptions', type: 'select', options: PERCEPTION_OPTIONS },
    { key: 'mseCognitionOrientation', label: 'Cognition / Orientation', type: 'text' },
    { key: 'mseInsight', label: 'Insight', type: 'select', options: INSIGHT_OPTIONS },
    { key: 'mseJudgment', label: 'Judgment', type: 'select', options: JUDGMENT_OPTIONS },
  ],
};

// ─── Note type configs ────────────────────────────────────────────────────────

export const NOTE_TYPE_CONFIGS = {
  soap: {
    label: 'SOAP Note',
    sections: [
      SESSION_INFO_SECTION,
      MENTAL_STATUS_BRIEF_SECTION,
      {
        title: 'Clinical Content',
        fields: [
          {
            key: 'presentingConcerns',
            label: 'Presenting Concerns (This Session)',
            type: 'textarea',
            rows: 3,
            hint: "What the client brought to today's session",
          },
          {
            key: 'subjective',
            label: 'Subjective (S)',
            type: 'textarea',
            rows: 5,
            hint: "Client's self-reported symptoms, feelings, and concerns since last session",
          },
          {
            key: 'objective',
            label: 'Objective (O)',
            type: 'textarea',
            rows: 5,
            hint: 'Clinician observations: appearance, affect, behavior, MSE findings',
          },
          {
            key: 'assessment',
            label: 'Assessment (A)',
            type: 'textarea',
            rows: 5,
            hint: 'Clinical interpretation, progress toward goals, diagnosis considerations',
          },
          {
            key: 'plan',
            label: 'Plan (P)',
            type: 'textarea',
            rows: 5,
            hint: 'Interventions used, next steps, homework, next appointment focus',
          },
        ],
      },
      SESSION_RISK_SECTION,
    ],
  },

  dap: {
    label: 'DAP Note',
    sections: [
      SESSION_INFO_SECTION,
      MENTAL_STATUS_BRIEF_SECTION,
      {
        title: 'Clinical Content',
        fields: [
          { key: 'presentingConcerns', label: 'Presenting Concerns (This Session)', type: 'textarea', rows: 3 },
          {
            key: 'data',
            label: 'Data (D)',
            type: 'textarea',
            rows: 6,
            hint: 'Objective and subjective information: what client reported and clinician observations',
          },
          { key: 'assessment', label: 'Assessment (A)', type: 'textarea', rows: 5, hint: 'Clinical interpretation and analysis of the data' },
          { key: 'plan', label: 'Plan (P)', type: 'textarea', rows: 5, hint: 'Next steps, interventions, goals update, next appointment' },
        ],
      },
      SESSION_RISK_SECTION,
    ],
  },

  progress: {
    label: 'Standard Progress Note',
    sections: [
      SESSION_INFO_SECTION,
      MENTAL_STATUS_BRIEF_SECTION,
      {
        title: 'Session Content',
        fields: [
          { key: 'presentingConcerns', label: 'Presenting Concerns (This Session)', type: 'textarea', rows: 3 },
          { key: 'sessionSummary', label: 'Session Summary', type: 'textarea', rows: 6 },
          { key: 'interventionsUsed', label: 'Interventions Used', type: 'checkboxes', options: EBI_OPTIONS },
          { key: 'interventionsOther', label: 'Other Interventions', type: 'text', placeholder: 'Describe other interventions…' },
          { key: 'clientResponse', label: "Client's Response to Treatment", type: 'textarea', rows: 3 },
          { key: 'progressTowardGoals', label: 'Progress Toward Treatment Goals', type: 'textarea', rows: 3 },
          { key: 'plan', label: 'Plan / Next Session Focus', type: 'textarea', rows: 3 },
        ],
      },
      SESSION_RISK_SECTION,
    ],
  },

  intake: {
    label: 'Intake Note',
    sections: [
      {
        title: 'Referral & Presenting Problem',
        fields: [
          { key: 'referralSource', label: 'Referral Source', type: 'text' },
          { key: 'presentingProblem', label: 'Presenting Problem / Chief Complaint', type: 'textarea', rows: 4 },
          {
            key: 'historyOfPresentingProblem',
            label: 'History of Presenting Problem',
            type: 'textarea',
            rows: 4,
            hint: 'Onset, duration, precipitating factors, prior episodes',
          },
        ],
      },
      {
        title: 'Psychiatric & Medical History',
        fields: [
          { key: 'previousTreatment', label: 'Previous Mental Health Treatment', type: 'textarea', rows: 3 },
          { key: 'psychiatricHospitalizations', label: 'Psychiatric Hospitalizations', type: 'textarea', rows: 2 },
          { key: 'currentMedicationsPsych', label: 'Current Psychiatric Medications', type: 'textarea', rows: 2 },
          { key: 'medicalConditions', label: 'Medical Conditions', type: 'textarea', rows: 2 },
          { key: 'currentMedicationsMedical', label: 'Current Medical Medications / Allergies', type: 'textarea', rows: 2 },
        ],
      },
      {
        title: 'Substance Use',
        columns: 3,
        fields: [
          { key: 'substanceUseAlcohol', label: 'Alcohol', type: 'select', options: SUBSTANCE_ALCOHOL_OPTIONS },
          { key: 'substanceUseCannabis', label: 'Cannabis', type: 'select', options: SUBSTANCE_CANNABIS_OPTIONS },
          { key: 'substanceUseOther', label: 'Other Substances', type: 'text' },
          { key: 'substanceUseTreatmentHistory', label: 'Substance Use Treatment History', type: 'textarea', rows: 2 },
        ],
      },
      {
        title: 'Psychosocial History',
        fields: [
          { key: 'familyHistory', label: 'Family Mental Health History', type: 'textarea', rows: 2 },
          {
            key: 'psychosocialHistory',
            label: 'Psychosocial / Developmental History',
            type: 'textarea',
            rows: 3,
            hint: 'Family of origin, childhood, adverse experiences',
          },
          { key: 'traumaHistory', label: 'Trauma History', type: 'textarea', rows: 2 },
          { key: 'relationshipStatus', label: 'Relationship Status', type: 'select', options: RELATIONSHIP_STATUS_OPTIONS },
          { key: 'currentLivingSituation', label: 'Current Living Situation', type: 'text' },
          { key: 'educationalVocationalHistory', label: 'Educational / Vocational History', type: 'textarea', rows: 2 },
          { key: 'socialSupport', label: 'Social Support', type: 'textarea', rows: 2 },
          { key: 'legalHistory', label: 'Legal History', type: 'text' },
          { key: 'culturalConsiderations', label: 'Cultural / Spiritual Considerations', type: 'textarea', rows: 2 },
        ],
      },
      MSE_COLUMNS_SECTION,
      {
        title: 'Risk Assessment',
        columns: 2,
        fields: [
          { key: 'riskSuicidalIdeation', label: 'Suicidal Ideation', type: 'select', options: SI_OPTIONS },
          { key: 'riskHomicidalIdeation', label: 'Homicidal Ideation', type: 'select', options: HI_OPTIONS },
          { key: 'riskSelfHarm', label: 'Self-Harm', type: 'select', options: SH_OPTIONS },
          { key: 'riskLevel', label: 'Overall Risk Level', type: 'select', options: RISK_LEVEL_OPTIONS },
          { key: 'riskProtectiveFactors', label: 'Protective Factors', type: 'textarea', rows: 2 },
          { key: 'riskActionTaken', label: 'Action Taken', type: 'textarea', rows: 2 },
        ],
      },
      {
        title: 'Clinical Impressions & Recommendations',
        fields: [
          { key: 'diagnosticImpressions', label: 'Diagnostic Impressions (DSM-5)', type: 'textarea', rows: 3 },
          { key: 'treatmentRecommendations', label: 'Treatment Recommendations', type: 'textarea', rows: 3 },
          { key: 'recommendedModality', label: 'Recommended Modality', type: 'checkboxes', options: MODALITY_OPTIONS },
          { key: 'recommendedFrequency', label: 'Recommended Frequency', type: 'text', placeholder: 'e.g., Weekly, Biweekly' },
          { key: 'prognosis', label: 'Prognosis', type: 'select', options: PROGNOSIS_OPTIONS },
        ],
      },
    ],
  },

  initial_assessment: {
    label: 'Initial Clinical Mental Health Assessment',
    sections: [
      {
        title: 'Reason for Services',
        fields: [
          { key: 'referralSource', label: 'Referral Source', type: 'text' },
          { key: 'chiefComplaint', label: 'Chief Complaint / Reason for Seeking Services', type: 'textarea', rows: 4 },
          {
            key: 'historyOfPresentingProblem',
            label: 'History of Presenting Problem',
            type: 'textarea',
            rows: 5,
            hint: 'Onset, duration, precipitating factors, previous treatment for this concern',
          },
        ],
      },
      {
        title: 'Psychiatric History',
        fields: [
          { key: 'previousDiagnoses', label: 'Previous Diagnoses', type: 'textarea', rows: 2 },
          { key: 'previousOutpatientTreatment', label: 'Previous Outpatient Treatment', type: 'textarea', rows: 2 },
          { key: 'psychiatricHospitalizations', label: 'Psychiatric Hospitalizations', type: 'textarea', rows: 2 },
          { key: 'suicideAttemptsHistory', label: 'Suicide Attempts / Self-Harm History', type: 'textarea', rows: 2 },
          { key: 'currentMedicationsPsych', label: 'Current Psychiatric Medications', type: 'textarea', rows: 2 },
        ],
      },
      {
        title: 'Substance Use History',
        columns: 3,
        fields: [
          { key: 'substanceUseAlcohol', label: 'Alcohol', type: 'select', options: SUBSTANCE_ALCOHOL_OPTIONS },
          { key: 'substanceUseCannabis', label: 'Cannabis', type: 'select', options: SUBSTANCE_CANNABIS_OPTIONS },
          { key: 'substanceUseOther', label: 'Other Substances', type: 'text' },
          { key: 'substanceUseTreatmentHistory', label: 'Substance Use Treatment History', type: 'textarea', rows: 2 },
        ],
      },
      {
        title: 'Medical History',
        columns: 2,
        fields: [
          { key: 'medicalConditions', label: 'Significant Medical Conditions', type: 'textarea', rows: 2 },
          { key: 'currentMedicationsMedical', label: 'Current Medical Medications', type: 'textarea', rows: 2 },
          { key: 'allergies', label: 'Allergies', type: 'text' },
          { key: 'lastPhysicalExam', label: 'Last Physical Exam', type: 'text' },
        ],
      },
      {
        title: 'Psychosocial / Developmental History',
        fields: [
          { key: 'familyOfOriginChildhood', label: 'Family of Origin / Childhood', type: 'textarea', rows: 3 },
          { key: 'traumaAdverseExperiences', label: 'Trauma / Adverse Experiences', type: 'textarea', rows: 3 },
          { key: 'educationalHistory', label: 'Educational History', type: 'textarea', rows: 2 },
          { key: 'vocationalHistory', label: 'Vocational History', type: 'textarea', rows: 2 },
          { key: 'relationshipStatus', label: 'Relationship Status', type: 'select', options: RELATIONSHIP_STATUS_OPTIONS },
          { key: 'currentLivingSituation', label: 'Current Living Situation', type: 'text' },
          { key: 'children', label: 'Children', type: 'text' },
          { key: 'legalHistory', label: 'Legal History', type: 'text' },
          { key: 'culturalSpiritualConsiderations', label: 'Cultural / Spiritual Considerations', type: 'textarea', rows: 2 },
          { key: 'socialSupports', label: 'Social Supports', type: 'textarea', rows: 2 },
        ],
      },
      {
        title: 'Mental Status Examination',
        columns: 2,
        fields: [
          { key: 'mseAppearance', label: 'Appearance', type: 'text' },
          { key: 'mseBehaviorPsychomotor', label: 'Behavior / Psychomotor Activity', type: 'text' },
          { key: 'mseAttitudeTowardExaminer', label: 'Attitude Toward Examiner', type: 'text' },
          { key: 'mseSpeech', label: 'Speech', type: 'text' },
          { key: 'mseMood', label: 'Mood (Client Report)', type: 'select', options: MOOD_OPTIONS },
          { key: 'mseAffect', label: 'Affect (Clinician Observation)', type: 'select', options: AFFECT_OPTIONS },
          { key: 'mseThoughtProcess', label: 'Thought Process', type: 'select', options: THOUGHT_PROCESS_OPTIONS },
          { key: 'mseThoughtContent', label: 'Thought Content', type: 'text', hint: 'Preoccupations, delusions' },
          { key: 'msePerceptions', label: 'Perceptual Disturbances', type: 'select', options: PERCEPTION_OPTIONS },
          { key: 'mseCognitionOrientation', label: 'Cognition / Orientation', type: 'text' },
          {
            key: 'mseMemory',
            label: 'Memory',
            type: 'select',
            options: [
              { value: '', label: '— Select —' },
              { value: 'intact', label: 'Intact' },
              { value: 'mildly_impaired', label: 'Mildly impaired' },
              { value: 'moderately_impaired', label: 'Moderately impaired' },
              { value: 'severely_impaired', label: 'Severely impaired' },
            ],
          },
          {
            key: 'mseConcentration',
            label: 'Concentration',
            type: 'select',
            options: [
              { value: '', label: '— Select —' },
              { value: 'intact', label: 'Intact' },
              { value: 'mildly_impaired', label: 'Mildly impaired' },
              { value: 'moderately_impaired', label: 'Moderately impaired' },
            ],
          },
          { key: 'mseInsight', label: 'Insight', type: 'select', options: INSIGHT_OPTIONS },
          { key: 'mseJudgment', label: 'Judgment', type: 'select', options: JUDGMENT_OPTIONS },
        ],
      },
      {
        title: 'Risk Assessment',
        columns: 2,
        fields: [
          { key: 'riskSuicidalIdeation', label: 'Suicidal Ideation', type: 'select', options: SI_OPTIONS },
          { key: 'riskHomicidalIdeation', label: 'Homicidal Ideation', type: 'select', options: HI_OPTIONS },
          { key: 'riskSelfHarm', label: 'Self-Harm', type: 'select', options: SH_OPTIONS },
          { key: 'riskAccessToMeans', label: 'Access to Means', type: 'text' },
          { key: 'riskLevel', label: 'Overall Risk Level', type: 'select', options: RISK_LEVEL_OPTIONS },
          { key: 'riskProtectiveFactors', label: 'Protective Factors', type: 'textarea', rows: 2 },
          { key: 'riskActionTaken', label: 'Action Taken', type: 'textarea', rows: 2 },
        ],
      },
      {
        title: 'Diagnosis & Clinical Formulation',
        fields: [
          { key: 'diagnosisPrimary', label: 'Primary Diagnosis (DSM-5)', type: 'text', placeholder: 'e.g., F33.1 Major Depressive Disorder, Moderate' },
          { key: 'diagnosisSecondary', label: 'Secondary Diagnosis', type: 'text' },
          { key: 'diagnosisRuleOut', label: 'Rule Out', type: 'text' },
          { key: 'diagnosisMedical', label: 'Medical Diagnosis (relevant)', type: 'text' },
          {
            key: 'clinicalFormulation',
            label: 'Clinical Formulation',
            type: 'textarea',
            rows: 5,
            hint: 'Biopsychosocial conceptualization of presenting concerns',
          },
        ],
      },
      {
        title: 'Treatment Recommendations',
        fields: [
          { key: 'recommendedModality', label: 'Recommended Modality', type: 'checkboxes', options: MODALITY_OPTIONS },
          { key: 'recommendedFrequency', label: 'Frequency', type: 'text', placeholder: 'e.g., Weekly' },
          { key: 'recommendedInterventions', label: 'Recommended Interventions', type: 'textarea', rows: 3 },
          { key: 'referrals', label: 'Referrals', type: 'textarea', rows: 2 },
          { key: 'prognosis', label: 'Prognosis', type: 'select', options: PROGNOSIS_OPTIONS },
        ],
      },
    ],
  },

  assessment: {
    label: 'Assessment (General)',
    sections: [
      {
        title: 'Assessment',
        fields: [
          { key: 'purposeReferralQuestion', label: 'Purpose / Referral Question', type: 'textarea', rows: 3 },
          { key: 'relevantBackground', label: 'Relevant Background Information', type: 'textarea', rows: 4 },
          { key: 'behavioralObservations', label: 'Behavioral Observations', type: 'textarea', rows: 4 },
          { key: 'assessmentFindings', label: 'Assessment Findings', type: 'textarea', rows: 5 },
          { key: 'clinicalImpressions', label: 'Clinical Impressions / Formulation', type: 'textarea', rows: 4 },
          { key: 'diagnosisPrimary', label: 'Primary Diagnosis (DSM-5)', type: 'text' },
          { key: 'diagnosisSecondary', label: 'Secondary Diagnosis', type: 'text' },
          { key: 'recommendations', label: 'Recommendations', type: 'textarea', rows: 4 },
        ],
      },
      SESSION_RISK_SECTION,
    ],
  },

  treatment_plan: {
    label: 'Treatment Plan & Goals',
    sections: [
      {
        title: 'Diagnosis & Parameters',
        columns: 2,
        fields: [
          { key: 'diagnosisPrimary', label: 'Primary Diagnosis (DSM-5)', type: 'text', placeholder: 'e.g., F33.1 MDD, Moderate' },
          { key: 'diagnosisSecondary', label: 'Secondary Diagnosis', type: 'text' },
          {
            key: 'levelOfCare',
            label: 'Level of Care',
            type: 'select',
            options: [
              { value: '', label: '— Select —' },
              { value: 'outpatient', label: 'Outpatient' },
              { value: 'intensive_outpatient', label: 'Intensive Outpatient (IOP)' },
              { value: 'partial_hospitalization', label: 'Partial Hospitalization (PHP)' },
            ],
          },
          { key: 'sessionFrequency', label: 'Session Frequency', type: 'text', placeholder: 'e.g., Weekly' },
          { key: 'estimatedDuration', label: 'Estimated Treatment Duration', type: 'text', placeholder: 'e.g., 3–6 months' },
          { key: 'reviewDate', label: 'Plan Review Date', type: 'date' },
        ],
      },
      {
        title: 'Treatment Modality',
        fields: [
          { key: 'treatmentModality', label: 'Modality', type: 'checkboxes', options: MODALITY_OPTIONS },
        ],
      },
      {
        title: 'Client Profile',
        fields: [
          { key: 'presentingProblem', label: 'Presenting Problem / Focus of Treatment', type: 'textarea', rows: 3 },
          { key: 'clientStrengths', label: 'Client Strengths & Resources', type: 'textarea', rows: 3 },
          { key: 'barriersTreatment', label: 'Barriers to Treatment', type: 'textarea', rows: 2 },
        ],
      },
      {
        title: 'Treatment Goals',
        fields: [
          {
            key: 'goals',
            label: 'Goals',
            type: 'array',
            addLabel: 'Add Goal',
            itemLabel: 'Goal',
            itemFields: [
              { key: 'problemStatement', label: 'Problem Statement', type: 'text' },
              { key: 'longTermGoal', label: 'Long-Term Goal', type: 'textarea', rows: 2 },
              { key: 'objectives', label: 'Short-Term Objectives', type: 'textarea', rows: 2 },
              { key: 'interventions', label: 'Interventions', type: 'textarea', rows: 2 },
              { key: 'progressIndicators', label: 'Measurable Progress Indicators', type: 'text' },
              { key: 'targetDate', label: 'Target Date', type: 'date' },
              { key: 'status', label: 'Status', type: 'select', options: GOAL_STATUS_OPTIONS },
            ],
          },
        ],
      },
    ],
  },

  behavioral_tx_plan: {
    label: 'Behavioral Health Treatment Plan',
    sections: [
      {
        title: 'Diagnosis',
        columns: 2,
        fields: [
          { key: 'diagnosisPrimary', label: 'Primary Diagnosis (DSM-5)', type: 'text' },
          { key: 'diagnosisSecondary', label: 'Secondary Diagnosis', type: 'text' },
          { key: 'reviewDate', label: 'Review Date', type: 'date' },
        ],
      },
      {
        title: 'Presenting Problem & Functional Impairment',
        fields: [
          { key: 'presentingProblem', label: 'Problem Description', type: 'textarea', rows: 3 },
          {
            key: 'functionalImpairment',
            label: 'Functional Impairment Areas',
            type: 'checkboxes',
            options: [
              { value: 'occupational', label: 'Occupational / School' },
              { value: 'social', label: 'Social / Interpersonal' },
              { value: 'adl', label: 'Activities of Daily Living' },
              { value: 'self_care', label: 'Self-Care' },
              { value: 'family', label: 'Family Functioning' },
            ],
          },
          { key: 'strengths', label: 'Strengths & Protective Factors', type: 'textarea', rows: 3 },
        ],
      },
      {
        title: 'Treatment Goals & Objectives',
        fields: [
          {
            key: 'goals',
            label: 'Goals',
            type: 'array',
            addLabel: 'Add Goal',
            itemLabel: 'Goal',
            itemFields: [
              { key: 'longTermGoal', label: 'Long-Term Goal', type: 'textarea', rows: 2 },
              { key: 'shortTermObjective', label: 'Short-Term Objective', type: 'textarea', rows: 2 },
              { key: 'intervention', label: 'Intervention', type: 'textarea', rows: 2 },
              { key: 'outcomeMeasure', label: 'Outcome Measure', type: 'text' },
              { key: 'targetDate', label: 'Target Date', type: 'date' },
              { key: 'status', label: 'Status', type: 'select', options: GOAL_STATUS_OPTIONS },
            ],
          },
        ],
      },
      {
        title: 'Evidence-Based Interventions',
        fields: [
          { key: 'evidenceBasedInterventions', label: 'Interventions', type: 'checkboxes', options: EBI_OPTIONS },
          { key: 'otherInterventions', label: 'Other Interventions', type: 'text' },
        ],
      },
      {
        title: 'Risk Status',
        columns: 2,
        fields: [
          {
            key: 'riskSuicidalIdeation',
            label: 'Suicidal Ideation',
            type: 'select',
            options: [
              { value: '', label: '— Select —' },
              { value: 'none', label: 'None' },
              { value: 'low', label: 'Low' },
              { value: 'moderate', label: 'Moderate' },
              { value: 'high', label: 'High' },
            ],
          },
          {
            key: 'safetyPlanOnFile',
            label: 'Safety Plan on File',
            type: 'select',
            options: [
              { value: '', label: '— Select —' },
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' },
            ],
          },
        ],
      },
      {
        title: 'Treatment Parameters',
        columns: 2,
        fields: [
          { key: 'treatmentModality', label: 'Modality', type: 'checkboxes', options: MODALITY_OPTIONS },
          { key: 'sessionFrequency', label: 'Session Frequency', type: 'text' },
          { key: 'estimatedDuration', label: 'Estimated Duration', type: 'text' },
          { key: 'medications', label: 'Medications (if applicable)', type: 'textarea', rows: 2 },
          { key: 'referrals', label: 'Referrals / Coordination of Care', type: 'textarea', rows: 2 },
        ],
      },
    ],
  },

  couples_tx_plan: {
    label: 'Couples Behavioral Health Treatment Plan',
    sections: [
      {
        title: 'Relationship Context',
        columns: 2,
        fields: [
          {
            key: 'relationshipStatus',
            label: 'Relationship Status',
            type: 'select',
            options: [
              { value: '', label: '— Select —' },
              { value: 'dating', label: 'Dating' },
              { value: 'cohabiting', label: 'Cohabiting' },
              { value: 'engaged', label: 'Engaged' },
              { value: 'married', label: 'Married' },
              { value: 'separated', label: 'Separated' },
            ],
          },
          { key: 'relationshipDuration', label: 'Duration of Relationship', type: 'text', placeholder: 'e.g., 3 years' },
          { key: 'reviewDate', label: 'Review Date', type: 'date' },
        ],
      },
      {
        title: 'Presenting Concerns',
        fields: [
          { key: 'presentingConcernsCouple', label: 'Primary Concerns (Couple-Identified)', type: 'textarea', rows: 3 },
          { key: 'presentingConcernsSecondary', label: 'Secondary Concerns', type: 'textarea', rows: 2 },
          { key: 'client1IndividualConcerns', label: 'Individual Concerns — Partner 1', type: 'textarea', rows: 2 },
          { key: 'client2IndividualConcerns', label: 'Individual Concerns — Partner 2', type: 'textarea', rows: 2 },
        ],
      },
      {
        title: 'Relationship History & Context',
        fields: [
          { key: 'relationshipStrengths', label: 'Relationship Strengths', type: 'textarea', rows: 3 },
          { key: 'previousCouplesTherapy', label: 'Previous Couples / Individual Therapy', type: 'textarea', rows: 2 },
          { key: 'culturalFamilyOfOriginFactors', label: 'Cultural / Family-of-Origin Factors', type: 'textarea', rows: 2 },
        ],
      },
      {
        title: 'Treatment Goals',
        fields: [
          {
            key: 'goals',
            label: 'Goals',
            type: 'array',
            addLabel: 'Add Goal',
            itemLabel: 'Goal',
            itemFields: [
              { key: 'goal', label: 'Goal', type: 'textarea', rows: 2 },
              {
                key: 'focus',
                label: 'Focus',
                type: 'select',
                options: [
                  { value: '', label: '— Select —' },
                  { value: 'couple', label: 'Couple' },
                  { value: 'partner1', label: 'Partner 1' },
                  { value: 'partner2', label: 'Partner 2' },
                ],
              },
              { key: 'objectives', label: 'Objectives', type: 'textarea', rows: 2 },
              { key: 'interventions', label: 'Interventions', type: 'textarea', rows: 2 },
              { key: 'measurableIndicator', label: 'Measurable Indicator', type: 'text' },
              { key: 'targetDate', label: 'Target Date', type: 'date' },
            ],
          },
        ],
      },
      {
        title: 'Evidence-Based Interventions',
        fields: [
          {
            key: 'evidenceBasedInterventions',
            label: 'Interventions',
            type: 'checkboxes',
            options: [
              { value: 'gottman', label: 'Gottman Method' },
              { value: 'eft', label: 'Emotionally Focused Therapy (EFT)' },
              { value: 'cbct', label: 'Cognitive Behavioral Couples Therapy' },
              { value: 'imago', label: 'Imago Relationship Therapy' },
              { value: 'narrative', label: 'Narrative Therapy' },
              { value: 'communication', label: 'Communication Skills Training' },
              { value: 'conflict', label: 'Conflict Resolution Strategies' },
            ],
          },
          { key: 'otherInterventions', label: 'Other', type: 'text' },
        ],
      },
      {
        title: 'Treatment Parameters',
        columns: 2,
        fields: [
          { key: 'sessionFrequency', label: 'Frequency', type: 'text' },
          {
            key: 'format',
            label: 'Format',
            type: 'select',
            options: [
              { value: '', label: '— Select —' },
              { value: 'conjoint_only', label: 'Conjoint only' },
              { value: 'individual_plus_conjoint', label: 'Individual + Conjoint' },
              { value: 'telehealth', label: 'Telehealth' },
            ],
          },
          { key: 'estimatedDuration', label: 'Estimated Duration', type: 'text' },
        ],
      },
    ],
  },

  discharge: {
    label: 'Discharge Summary',
    sections: [
      {
        title: 'Discharge Information',
        columns: 2,
        fields: [
          { key: 'diagnosisAtDischarge', label: 'Diagnosis at Discharge (DSM-5)', type: 'text' },
          {
            key: 'dischargeReason',
            label: 'Reason for Discharge',
            type: 'select',
            options: [
              { value: '', label: '— Select —' },
              { value: 'goals_met', label: 'Treatment goals met' },
              { value: 'client_request', label: 'Client request / voluntary discharge' },
              { value: 'non_compliance', label: 'Non-compliance / missed appointments' },
              { value: 'higher_level_care', label: 'Transferred to higher level of care' },
              { value: 'lower_level_care', label: 'Transferred to lower level of care' },
              { value: 'relocation', label: 'Moved / geographic relocation' },
              { value: 'loss_to_followup', label: 'Loss to follow-up' },
              { value: 'other', label: 'Other' },
            ],
          },
          { key: 'dischargeReasonOther', label: 'Other Reason (if applicable)', type: 'text' },
        ],
      },
      {
        title: 'Treatment Summary',
        columns: 2,
        fields: [
          { key: 'presentingProblemsAtIntake', label: 'Presenting Problems at Intake', type: 'textarea', rows: 3 },
          { key: 'totalSessionsAttended', label: 'Total Sessions Attended', type: 'number' },
          { key: 'treatmentDuration', label: 'Treatment Duration', type: 'text', placeholder: 'e.g., 8 months' },
          { key: 'treatmentModality', label: 'Treatment Modality', type: 'text' },
          { key: 'interventionsUsed', label: 'Interventions Used', type: 'textarea', rows: 2 },
        ],
      },
      {
        title: 'Goals & Outcomes',
        fields: [
          {
            key: 'goals',
            label: 'Goals',
            type: 'array',
            addLabel: 'Add Goal',
            itemLabel: 'Goal',
            itemFields: [
              { key: 'goal', label: 'Goal', type: 'textarea', rows: 2 },
              {
                key: 'status',
                label: 'Status',
                type: 'select',
                options: [
                  { value: '', label: '— Select —' },
                  { value: 'met', label: 'Met' },
                  { value: 'partially_met', label: 'Partially met' },
                  { value: 'not_met', label: 'Not met' },
                ],
              },
              { key: 'notes', label: 'Notes', type: 'textarea', rows: 2 },
            ],
          },
        ],
      },
      {
        title: 'Clinical Status at Discharge',
        columns: 2,
        fields: [
          { key: 'clinicalProgressSummary', label: 'Clinical Progress Summary', type: 'textarea', rows: 4 },
          { key: 'mseAtDischargeMood', label: 'Mood at Discharge', type: 'select', options: MOOD_OPTIONS },
          { key: 'mseAtDischargeAffect', label: 'Affect at Discharge', type: 'select', options: AFFECT_OPTIONS },
          { key: 'functioningAtDischarge', label: 'Functioning at Discharge', type: 'textarea', rows: 2 },
          { key: 'riskLevel', label: 'Risk Level at Discharge', type: 'select', options: RISK_LEVEL_OPTIONS },
          {
            key: 'suicidalIdeationAtDischarge',
            label: 'Suicidal Ideation at Discharge',
            type: 'select',
            options: [
              { value: '', label: '— Select —' },
              { value: 'none', label: 'None' },
              { value: 'present', label: 'Present' },
            ],
          },
          {
            key: 'safetyPlanProvided',
            label: 'Safety Plan Provided',
            type: 'select',
            options: [
              { value: '', label: '— Select —' },
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' },
            ],
          },
          { key: 'medicationsAtDischarge', label: 'Medications at Discharge', type: 'textarea', rows: 2 },
        ],
      },
      {
        title: 'Aftercare Plan',
        fields: [
          { key: 'aftercareFollowUp', label: 'Follow-Up Care Recommended', type: 'textarea', rows: 2 },
          { key: 'referralsMade', label: 'Referrals Made', type: 'textarea', rows: 2 },
          { key: 'resourcesProvided', label: 'Resources Provided', type: 'textarea', rows: 2 },
          { key: 'returnToTreatmentInstructions', label: 'Return to Treatment Instructions', type: 'textarea', rows: 2 },
        ],
      },
    ],
  },

  good_faith_estimate: {
    label: 'Good Faith Estimate',
    sections: [
      {
        title: 'Estimate Details',
        columns: 2,
        fields: [
          { key: 'estimatedStartDate', label: 'Estimated Start Date of Services', type: 'date' },
          {
            key: 'reasonForEstimate',
            label: 'Reason for Estimate',
            type: 'checkboxes',
            options: [
              { value: 'client_requested', label: 'Client/patient requested' },
              { value: 'uninsured', label: 'Uninsured / self-pay client' },
              { value: 'out_of_network', label: 'Out-of-network services' },
            ],
          },
        ],
      },
      {
        title: 'Estimated Services & Costs',
        fields: [
          {
            key: 'services',
            label: 'Services',
            type: 'array',
            addLabel: 'Add Service',
            itemLabel: 'Service',
            itemFields: [
              { key: 'description', label: 'Service Description', type: 'text', placeholder: 'e.g., Individual psychotherapy (53 min)' },
              { key: 'cptCode', label: 'CPT Code', type: 'text', placeholder: 'e.g., 90837' },
              { key: 'costPerSession', label: 'Est. Cost Per Session ($)', type: 'number' },
              { key: 'estimatedSessions', label: 'Est. # Sessions', type: 'number' },
            ],
          },
        ],
      },
      {
        title: 'Totals',
        columns: 2,
        fields: [
          { key: 'estimatedTotalSessions', label: 'Estimated Total Sessions', type: 'number' },
          { key: 'estimatedTreatmentDuration', label: 'Estimated Treatment Duration', type: 'text', placeholder: 'e.g., 6–12 months' },
          { key: 'estimatedTotalCost', label: 'Estimated Total Cost ($)', type: 'number' },
        ],
      },
      {
        title: 'Additional Notes',
        fields: [
          { key: 'additionalNotes', label: 'Additional Notes', type: 'textarea', rows: 3 },
        ],
      },
    ],
  },
};

export const STRUCTURED_NOTE_TYPES = new Set(Object.keys(NOTE_TYPE_CONFIGS));

/**
 * Parses note content — returns { isStructured, data }.
 * Structured notes are JSON objects with _format: 'structured_json'.
 * All other content is treated as legacy plain text.
 */
export function parseNoteContent(content) {
  if (!content) return { isStructured: false, data: '' };
  try {
    const parsed = JSON.parse(content);
    if (parsed && parsed._format === 'structured_json') {
      // eslint-disable-next-line no-unused-vars
      const { _format, ...data } = parsed;
      return { isStructured: true, data };
    }
  } catch {
    // not JSON
  }
  return { isStructured: false, data: content };
}

export function serializeStructuredContent(data) {
  return JSON.stringify({ _format: 'structured_json', ...data });
}
